import React from "react";
import { Progress } from "@/components/ui/progress";

interface MonthlyBreakdownData {
  month: string;
  totalMeetings: number;
  totalAttendance: number;
  averageAttendance: number;
}

interface MonthlyBreakdownChartProps {
  data: MonthlyBreakdownData[];
}

export function MonthlyBreakdownChart({ data }: MonthlyBreakdownChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground">
        <div className="text-center">
          <div className="text-4xl mb-2">📈</div>
          <p>No monthly data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {data.map((item, index) => (
        <div key={index} className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="font-medium">{item.month}</div>
            <div className="text-sm text-muted-foreground">
              {item.averageAttendance}% ({item.totalMeetings} meetings)
            </div>
          </div>
          <Progress 
            value={item.averageAttendance} 
            className="h-2"
          />
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>0%</span>
            <span>50%</span>
            <span>100%</span>
          </div>
        </div>
      ))}
      
      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <div className="text-sm font-medium mb-2">Summary</div>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div>
            <span className="text-muted-foreground">Total Meetings:</span>
            <span className="ml-2 font-medium">
              {data.reduce((sum, item) => sum + item.totalMeetings, 0)}
            </span>
          </div>
          <div>
            <span className="text-muted-foreground">Avg Attendance:</span>
            <span className="ml-2 font-medium">
              {Math.round(data.reduce((sum, item) => sum + item.averageAttendance, 0) / data.length)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
